import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { FaClock, FaSave } from 'react-icons/fa';
import axios from 'axios';

const PriorBooking = () => {
  const [settings, setSettings] = useState({
    minHoursBeforeBooking: 3,
    instantBookingMessage: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem('adminToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/prior-booking`, {
          headers: { 'x-auth-token': token }
        });
        setSettings(response.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to load settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${process.env.REACT_APP_API_URL}/admin/prior-booking`, settings, {
        headers: { 'x-auth-token': token }
      });
      setIsEditing(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update settings');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div className="prior-booking-container">
      <h2 className="mb-4">
        <FaClock className="me-2" />
        Prior Booking Settings
      </h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Card>
        <Card.Body>
          {isEditing ? (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Minimum Hours Before Booking</Form.Label>
                <Form.Control
                  type="number"
                  name="minHoursBeforeBooking"
                  value={settings.minHoursBeforeBooking}
                  onChange={handleChange}
                  min="1"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Instant Booking Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="instantBookingMessage"
                  value={settings.instantBookingMessage}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="d-flex justify-content-end gap-2">
                <Button 
                  variant="secondary" 
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </Button>
                <Button 
                  variant="primary" 
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <FaSave className="me-2" />
                      Save Changes
                    </>
                  )}
                </Button>
              </div>
            </Form>
          ) : (
            <>
              <div className="mb-3">
                <h5>Minimum Hours Before Booking:</h5>
                <p>{settings.minHoursBeforeBooking} hours</p>
              </div>

              <div className="mb-3">
                <h5>Instant Booking Message:</h5>
                <p>{settings.instantBookingMessage}</p>
              </div>

              <Button 
                variant="primary" 
                onClick={() => setIsEditing(true)}
              >
                Edit Settings
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PriorBooking;